export default "__VITE_ASSET__C7ZV_Ww3__"